import { Link } from "react-router-dom";
import { FC } from "react";
import ContentContainer from "../../../../components/basics/ContentContainer";

type FooterProps = {
  footer: any;
};

const RenewalFooter: FC<React.PropsWithChildren<FooterProps>> = ({ footer }) => {
  return (
    <>
      <div className="pt-4 pb-4 md:pb-4 xxl:pb-4 bg-white">
        <ContentContainer omitTopPadding>
          <p className="text-black text-sm">{footer("note")}</p>
        </ContentContainer>
      </div>
      <div className="py-1 pb-4 bg-white">
        <ContentContainer omitTopPadding>
          <div className="flex flex-col md:flex-row">
            <div className="flex md:justify-between text-black text-sm pt-4 md:pt-0">
              <Link to={footer("privacyPolicyUrl")} className="hover:text-red" target="_blank">
                {footer("button.privacyPolicy")}
              </Link>
              <p className="px-2">|</p>
              <Link to={footer("termsConditionsUrl")} className="hover:text-red" target="_blank">
                {footer("button.termsConditions")}
              </Link>
              <p className="px-2 hidden md:block">|</p>
            </div>
            <p className="text-black text-sm">{footer("copyright")}</p>
          </div>
        </ContentContainer>
      </div>
    </>
  );
};

export default RenewalFooter;
